export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ05.b3788017.mp3";